import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Alert from "@mui/material/Alert";

import {useCollection} from "react-firebase-hooks/firestore";
import {collection} from "firebase/firestore";

import Title from "../common/Title";
import Loading from "../common/Loading";
import {getFirebase} from "../../config/firebase.config";

const AccountRequests = ({handleAccountEdit}) => {
    const {firestore} = getFirebase();
    const [value, loading, error] = useCollection(
        collection(firestore, 'accountRequests'),
        {
            snapshotListenOptions: {includeMetadataChanges: true},
        }
    );
    const handleEdit = (editObj) => {
        handleAccountEdit(editObj);
    }
    if (loading) {
        return <Loading />
    }
    return (
        <React.Fragment>
            <Title>Employee Requests</Title>
            {error && <Alert severity="error">{error.message}</Alert>}
            <TableContainer component={Paper} sx={{maxHeight: 250}}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Employee Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Employee Id</TableCell>
                            <TableCell align={"justify"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {value && value.docs.map((doc) => (
                            <TableRow key={doc.id}>
                                <TableCell>{doc.data().date.toDate().toLocaleString()}</TableCell>
                                <TableCell>{doc.data().empName}</TableCell>
                                <TableCell>{doc.data().email}</TableCell>
                                <TableCell>{doc.data().empId}</TableCell>
                                <TableCell>
                                    <IconButton aria-label="edit" size={"small"} onClick={(e) => handleEdit(doc.data())}>
                                        <EditIcon/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
};

export default AccountRequests;